import {cx} from '@emotion/css';
import React, {ReactElement} from 'react';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';
import {DEFAULT_LOCALE} from '@fo/shared-types/constants';

import styles from './CalculatorResultItem.styles';

interface Props {
  title: string;
  value?: string;
  bordered?: boolean;
  template?: (templateValue: string) => string;
}

function CalculatorResultItem({
  title,
  value,
  bordered,
  template = (templateValue: string) => templateValue,
}: Props): ReactElement {
  const defaultValue = '-';

  const getValue = () => {
    if (value?.length) {
      const formattedValue = Number(value).toLocaleString(DEFAULT_LOCALE, {useGrouping: true});
      return template(formattedValue);
    }

    return defaultValue;
  };

  return (
    <div className={cx(styles.calculatorResult(bordered))}>
      <Paragraph className={cx(styles.title)}>{title}</Paragraph>
      <Paragraph className={cx(styles.value)}>{getValue()}</Paragraph>
    </div>
  );
}

export default CalculatorResultItem;
